import { Box } from '@mui/material';
import React from 'react';

export interface BottomDockProps {
  center?: React.ReactNode;
  right?: React.ReactNode;
  sx?: object;
}

const BottomDock: React.FC<BottomDockProps> = ({ center, right, sx }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 2,
        px: 2,
        pointerEvents: 'none',
        '& > *': { pointerEvents: 'auto' },
        ...sx,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: 0,
        }}
      >
        {center}
      </Box>
      {right != null ? <Box sx={{ flexShrink: 0, ml: 1 }}>{right}</Box> : null}
    </Box>
  );
};

export default BottomDock;
